module.exports = __webpack_public_path__ + "img/EP18Menu1.f80f3f67.png";